import React, { useState, useRef, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { FaUser, FaEnvelope, FaPhone, FaMapMarkerAlt } from "react-icons/fa";
import { FaPen } from "react-icons/fa6";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";

const RequestQuote = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    email: "",
    City: "",
    phone: "",
    zipcode: "",
    State: "",
    interested: "",
    message: "",
    image: null,
  });

  const [successMessageVisible, setSuccessMessageVisible] = useState(false);
  const [zeroPriceProducts, setZeroPriceProducts] = useState([]);

  const successMessageRef = useRef(null);

  useEffect(() => {
    const fetchZeroPriceProducts = async () => {
      try {
        const baseUrl = process.env.REACT_APP_BASE_URL;
        const response = await axios.get(
          `${baseUrl}/api/show-zeroprice-products`
        );
        const products = response.data;
        console.log("Fetched Zero Price Products:", products);
        setZeroPriceProducts(products);
      } catch (error) {
        console.error("Error fetching zero price products:", error);
      }
    };
    fetchZeroPriceProducts();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "interestedProduct") {
      setFormData({
        ...formData,
        interested: value,
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const handleFileChange = (e) => {
    setFormData({
      ...formData,
      image: e.target.files[0],
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    for (const key in formData) {
      if (!formData[key] && key !== "image") {
        alert(`Please fill in the ${key}.`);
        return;
      }
    }

    const data = new FormData();
    data.append("firstName", formData.firstName);
    data.append("email", formData.email);
    data.append("City", formData.City);
    data.append("phone", formData.phone);
    data.append("zipcode", formData.zipcode);
    data.append("State", formData.State);
    data.append("interested", formData.interested);
    data.append("message", formData.message);
    data.append("image", formData.image);

    try {
      const baseUrl = process.env.REACT_APP_BASE_URL;
      const response = await axios.post(`${baseUrl}/api/request-quote`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      console.log("API response:", response.data);
      setSuccessMessageVisible(true);

      if (successMessageRef.current) {
        successMessageRef.current.scrollIntoView({ behavior: "smooth" });
      }
    } catch (error) {
      if (error.response) {
        console.error("Error submitting form:", error.response.data);
        alert(
          `Error: ${error.response.data.message || "Something went wrong."}`
        );
      } else {
        console.error("Error submitting form:", error.message);
        alert(`Error: ${error.message}`);
      }
    }
  };

  return (
    <div className="request-main">
      <Container>
        {successMessageVisible && (
          <div
            ref={successMessageRef}
            className="alert alert-success"
            role="alert"
          >
            Your Request Quote has been submitted!
          </div>
        )}
        <div className="my-container">
          <select
            className="form-control"
            name="interestedProduct"
            onChange={handleChange}
          >
            <option value="">Select A Product</option>
            {zeroPriceProducts.map((product) => (
              <option key={product.id} value={product.id}>
                {product.name}
              </option>
            ))}
          </select>
          <Row>
            <div className="request-form">
              <div className="request-border">
                <h1>Request a Quote</h1>
              </div>
              <form className="request_form" onSubmit={handleSubmit}>
                <Row>
                  <Col lg="6">
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Your Name"
                        name="firstName"
                        value={formData.firstName}
                        onChange={handleChange}
                      />
                    </div>
                    <span className="input-group-icon">
                      <FaUser />
                    </span>
                  </Col>
                  <Col lg="6">
                    <div className="input-group">
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Enter Email Address"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                      />
                    </div>
                    <span className="input-group-icon">
                      <FaEnvelope />
                    </span>
                  </Col>
                  <Col lg="6">
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="City"
                        name="City"
                        value={formData.City}
                        onChange={handleChange}
                      />
                    </div>
                    <span className="input-group-icon">
                      <FaMapMarkerAlt />
                    </span>
                  </Col>
                  <Col lg="6">
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Your Phone Number"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                      />
                    </div>
                    <span className="input-group-icon">
                      <FaPhone />
                    </span>
                  </Col>
                  <Col lg="6">
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Postal/ZIP Code"
                        name="zipcode"
                        value={formData.zipcode}
                        onChange={handleChange}
                      />
                    </div>
                  </Col>
                  <Col lg="6">
                    <div className="input-group">
                      <select
                        className="form-control"
                        name="State"
                        value={formData.State}
                        onChange={handleChange}
                      >
                        <option value="">Select State</option>
                        <option value="California">California</option>
                        <option value="New York">New York</option>
                        <option value="Texas">Texas</option>
                      </select>
                    </div>
                  </Col>
                  <Col lg="12">
                    <div className="input-group">
                      <select
                        className="form-control"
                        name="interested"
                        value={formData.interested}
                        onChange={handleChange}
                      >
                        <option value="">I'm interested in</option>
                        {zeroPriceProducts.map((product) => (
                          <option key={product.id} value={product.id}>
                            {product.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </Col>
                  <Col lg="12">
                    <div className="input-group">
                      <textarea
                        rows="6"
                        className="form-control"
                        placeholder="Dimensions and Other Notes"
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                      ></textarea>
                    </div>
                    <span className="input-group-icon1">
                      <FaPen />
                    </span>
                  </Col>
                  <Col lg="12">
                    <div className="input-group">
                      <input
                        type="file"
                        className="form-control"
                        name="image"
                        onChange={handleFileChange}
                      />
                    </div>
                  </Col>
                  <Col lg="12">
                    <div className="theme-group">
                      <button type="submit" className="custom_btn">
                        Submit Request
                      </button>
                    </div>
                  </Col>
                </Row>
              </form>
            </div>
          </Row>
        </div>
      </Container>
    </div>
  );
};

export default RequestQuote;
